import JsonLd from '@/components/JsonLd'
import { serviceSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import EngineeringHero from '@/components/sections/engineering/EngineeringHero'
import EngineeringServices from '@/components/sections/engineering/EngineeringServices'
import EngineeringPricing from '@/components/sections/engineering/EngineeringPricing'
import EngineeringContact from '@/components/sections/engineering/EngineeringContact'
import ServiceNav from '@/components/sections/ServiceNav'

export default function Engineering() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={serviceSchema({ name: 'Web Development', description: 'Fast, accessible digital experiences on modern tech stacks that leave legacy competitors in the dust.', path: '/engineering' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'Services', path: '/#services' }, { name: 'Engineering', path: '/engineering' }])} />
      <Navbar />
      <main>
        <EngineeringHero />
        <EngineeringServices />
        <EngineeringPricing />
        <EngineeringContact />
        <ServiceNav />
      </main>
      <Footer />
    </div>
  )
}
